import React from 'react';
import { Link } from 'react-router-dom';
import account, { hasSection } from '../data/account';

// Commerce section access (WORKSPACE_SECTION_ROLES.md 2026-10-23). The router wraps every Sales and Marketing route in
// section(name, element): without the grant the member gets this panel instead of the page (the nav already hides
// the group, so this is for a typed or old URL). The services refuse the same calls with 403 section_access_required.
const LABELS = {
  sales: 'Sales',
  marketing: 'Marketing'
};
const COVERS = {
  sales: 'Sales cockpit, Territory and Reps, Quotes, Stores and Forecasts',
  marketing: 'Autopilot, Market Intelligence, Website Analytics, Campaigns, Email, Social and Content Hub'
};
export function SectionDenied({
  section
}) {
  const acct = account.get() || {};
  const label = LABELS[section] || section;
  const others = Object.keys(LABELS).filter(s => s !== section && hasSection(s, acct.groups)).map(s => LABELS[s]);
  const route = typeof window !== 'undefined' ? window.location.pathname : '';
  return /*#__PURE__*/React.createElement("div", {
    className: "section-denied"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sd-card"
  }, /*#__PURE__*/React.createElement("p", {
    className: "sd-lbl"
  }, label), /*#__PURE__*/React.createElement("h2", null, "You don't have access to ", label), /*#__PURE__*/React.createElement("p", null, label, " (", COVERS[section], ") is turned off for you in ", acct.company || 'this workspace', ".", others.length ? ` Your access covers ${others.join(' and ')}, plus Products, Customers, Reports and Apps.` : ' Your access covers Products, Customers, Reports and Apps.'), /*#__PURE__*/React.createElement("p", null, "A workspace owner can add it on ", /*#__PURE__*/React.createElement("b", null, "account.plunk.io \u203A Members"), "."), /*#__PURE__*/React.createElement("div", {
    className: "sd-actions"
  }, /*#__PURE__*/React.createElement(Link, {
    className: "sd-btn",
    to: "/"
  }, "Back to Dashboard")), /*#__PURE__*/React.createElement("p", {
    className: "sd-code"
  }, route, " \xB7 section_access_required \xB7 ", section)));
}
export function section(name, el) {
  const acct = account.get() || {};
  return hasSection(name, acct.groups) ? el : /*#__PURE__*/React.createElement(SectionDenied, {
    section: name
  });
}